module.exports = __webpack_public_path__ + "static/media/yoga1.75935305.gif";